import DavidePolicino from '../../assets/davide-pollicino.jpg'
import Sophie from '../../assets/sophie-patterson.jpg'
import DavidePaci from '../../assets/davide-paci.jpg'

const data = [
        {
            id: 1,
            quote: "Pablo is a talent in software development, live project management, but above all, business vision and communication. We collaborated at taxcoder.cz, where we saw Pablo leading critical areas of the project, from deployment and management of the infrastructure on AWS, to the growth of the test suite, integration and management of packages such as payment gateways, but above all, exercising great capacity for leadership within the team.",
            avatar: DavidePolicino,
            name: 'Davide Pollicino',
            profession: 'Software Engineer @Microsoft & Mentor @Microsoft for Startups | Top Mentor @MentorCruise | Azure AI Engineer associate (OpenAI)'
        },
        {
            id: 2,
            quote: "Pablo is a delight to work with. Pablo successfully supported our international recruitment team with a wide variety of projects ranging across communications, data management, scholarship coordination and conversion activities. In every area, he proved to be versatile and an excellent communicator. Pablo is a valuable asset to our team and is exceptionally reliable, prompt and competent. Pablo recently aided our team by speaking at a partners conference about his student experience with multiple stakeholders fluently, confidently and convincingly. Pablo is a helpful, energetic and dedicated team member and I am happy to give my hearty recommendation.",
            avatar: Sophie,
            name: 'Sophie Patterson',
            profession: 'International Projects Officer @ The University of Edinburgh'
        },
        {
            id: 3,
            quote: "Working with Pablo is a guarantee of having a skilled team player onboard: always helpful and never backing down even from the most head-scratching bugs. His ability to research new subjects deeply helped us quite a lot at TaxCoder when developing our MVP.",
            avatar: DavidePaci,
            name: 'Davide Paci',
            profession: 'Software Engineer @thinkin'
        }
    ]

    export default data